module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0012.jpg?v=297d05d0";